import { Stack, H3, Button, colors } from "@carrotfertility/carotene"
import Locations from "components/views/home/navigation"
import React from "react"
import { useHistory } from "react-router-dom"
import { useIntl } from "react-intl"

const InsuranceExpired = (): JSX.Element => {
  const intl = useIntl()
  const history = useHistory()
  const buttonLabel = intl.formatMessage({ defaultMessage: "Update to access your funds" })
  const warningHeader = intl.formatMessage({ defaultMessage: "Your insurance info has expired" })

  const handleButtonClick = (): void => history.push(Locations.Home.EnrollmentFlowActive)

  return (
    <Stack
      padding="medium"
      direction="column"
      borderRadius="8px"
      spacing="medium"
      sx={{
        backgroundColor: "rgba(210, 101, 86, 0.2)"
      }}
    >
      <H3 sx={{ color: colors.base.black80, fontWeight: "700" }}>{warningHeader}</H3>
      <Button variant="secondary" onClick={handleButtonClick}>
        {buttonLabel}
      </Button>
    </Stack>
  )
}

export default InsuranceExpired
